import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>
      <h2 className="title">Get In Touch</h2>
      <p>
        I am currently looking for part-time/full time paid internship opportunities. Also I am
        always looking for meaningful ways to support underprivileged communities, in tech or
        otherwise. I can listen, observe, share, talk, understand, and do. Reach out for anything
        and everything, and I shall do my bit.
      </p>
      <p>
        Apart from that, my inbox is open to doubts or advice in tech, music, quality dank memes or
        even a simple 'hi'!
      </p>
      Drop a mail and I'll reply within a day or two.
      <div>
        <a className="email-link" href={`mailto:${email}`}>
          Say Hello
        </a>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
